//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiButton from "../button/Index.vue";
import { DEVICE } from "../../store/mutation-types";
import store from "../../store/index";

export default {
  name: "ConfirmComponent",
  components: { HiButton },
  computed: {
    isIos() {
      return store.getters[DEVICE] === "ios";
    },
  },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    input: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "",
    },
    // 标题
    title: {
      type: String,
      default: "",
    },
    // 中间文案
    text: {
      type: String,
      default: "",
    },
    // 取消按钮点击文案
    cancelText: {
      type: String,
    },
    // 确认按钮文案
    yesText: {
      type: String,
    },
    // 确定按钮点击事件
    yesEvent: {
      type: Function,
      default: () => {
        return async () => true;
      },
    },
    // 取消按钮点击事件
    cancelEvent: {
      type: Object,
    },
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: false,
    },
    inputValidate: {
      type: Object || Function,
      default: null,
    },
  },
  data() {
    return {
      showModal: this.show,
      inputVal: "",
      errorMsg: "",
      shake: false, // 验证是否错误，如果错误则抖动
    };
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
      if (val) {
        this.errorMsg = "";
        this.inputVal = "";
      }
    },
    show(val) {
      this.showModal = val;
    },
  },
  methods: {
    /**
     * 取消按钮点击事件
     */
    async cancelClick() {
      this.showModal = false;
    },
    /**
     * 确定按钮点击事件
     */
    async yesClick() {
      if (this.yesEvent) {
        // 如果有input则确认回调把值传入
        if (this.input !== undefined) {
          // 验证
          try {
            await this.inputValidate({ input: this.inputVal });
            this.errorMsg = "";
          } catch (e) {
            this.errorMsg = e.message;
            this.shake = true;
            setTimeout(() => {
              this.shake = false;
            }, 1000);
            return;
          }
          const success = await this.yesEvent(this.inputVal);
          this.showModal = !success;
        } else {
          this.showModal = !(await this.yesEvent());
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/confirm/Index.vue